class AssetOperatorStatus {
    static Active: string = "Active";
    static Inactive: string = "Inactive";
    static Demo: string = "Demo";
}

export {AssetOperatorStatus}
